<template lang="html">
  <div :id="`L${apartment.id}`" class="hidden">
    <div class="rounded bg-white p-4 w-64">
      <div class="flex items-center justify-between">
        <h2 class="text-lg font-semibold">
          {{ config.name }} {{ apartment.id }}
        </h2>
        <Status :status="apartment.status" />
      </div>
      <div class="border-t border-gray-300 mt-4 pt-2">
        <Detail
          v-for="item in apartment.details.slice(0, 3)"
          :label="item.label"
          :key="item.label"
          small
          >{{ item.value }}</Detail
        >
      </div>
    </div>
  </div>
</template>

<script>
import Detail from './Detail.vue';
import Status from './Status.vue';
export default {
  props: ['apartment', 'config'],
  components: {
    Detail,
    Status,
  },
  data: function () {
    return {
      status: status,
    };
  },
};
</script>
